import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import { IAddAssignment, TAssignmentParams } from "Shared/Types/assignment";
import { clearCurrentAssignment } from "./slice";
import { IReducerWithCallback } from "Shared/Types/shared";
import { LIMIT_VEHICLES } from "Shared/Constants/app";

export const addAssignment = createAsyncThunk(
  "assignment/addAssignment",
  async ({
    data,
    onSuccess,
    onError,
  }: IReducerWithCallback<IAddAssignment>) => {
    try {
      const response = await api.assignment.addAssignment(data);
      onSuccess?.(response.data);
      return response.data;
    } catch (error) {
      onError?.(error);
      console.error(error);
      throw error;
    }
  }
);

export const getAssignmentsList = createAsyncThunk(
  "assignment/getAssignmentsList",
  async (params: TAssignmentParams | null) => {
    try {
      const response = await api.assignment.getAssignmentsList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const getAssignment = createAsyncThunk(
  "assignment/getAssignment",
  async (id: string) => {
    try {
      const response = await api.assignment.getAssignment(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const deleteAssignment = createAsyncThunk(
  "assignment/deleteAssignment",
  async (id: string, { dispatch }) => {
    try {
      const response = await api.assignment.deleteAssignment(id);
      clearCurrentAssignment();
      dispatch(getAssignmentsList({ limit: LIMIT_VEHICLES }));
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const updateAssignment = createAsyncThunk(
  "assignment/updateAssignment",
  async (data: { id: string; values: IAddAssignment }, { dispatch }) => {
    try {
      const response = await api.assignment.updateAssignment(data);
      dispatch(getAssignmentsList({ limit: LIMIT_VEHICLES }));
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);
